export type SlotVariant =
  | "completed"
  | "in-session"
  | "pre-sign"
  | "check-in"
  | "scheduled"
  | "open-slot"
  | "over"
  | "delayed"
  | "stuck"
  | "canceled"
  | "empty";

export type NotarySegment = "TSA" | "PA";

export type BoardSegmentFilter = "all" | "tsa" | "preferred";

export type LaneTagVariant =
  | "default"
  | "slate"
  | "success"
  | "info"
  | "warning"
  | "error";

export type ClosingIcon = "headphone" | "person" | "stamp";

export interface RonMonitorSummary {
  scheduled: number;
  stuckClients: number;
  borrowerDelayed: number;
  notaryDelayed: number;
  runningOver: number;
  completed: number;
  completedScheduledDenominator: number;
  cancelled: number;
  openSlots: number | null;
  stuckThresholdMinutes: number;
}

export interface NotaryLaneStatus {
  label: string;
  tagVariant: LaneTagVariant;
}

export interface NotaryLane {
  notaryId: string;
  name: string;
  /** Null until notary classification has a data source. See story 292892. */
  segment: NotarySegment | null;
  currentStatus: NotaryLaneStatus;
}

export interface ClosingPill {
  packageId: number;
  notaryId: string | null;
  scheduledDateTime: string;
  variant: SlotVariant;
  delayMinutes: number | null;
  icon: ClosingIcon | null;
  loanNumber: string;
  orderNumber: string;
}

export interface RonMonitorBoard {
  generatedAt: string;
  summary: RonMonitorSummary;
  lanes: NotaryLane[];
  closings: ClosingPill[];
}

export interface ClosingDetailNotary {
  name: string;
  status: string;
  currently: string;
  reason: string | null;
  phone: string | null;
}

export interface ClosingDetailClient {
  name: string;
  /** Display label, not a role code. */
  role: string;
  currently: string;
  phone: string | null;
}

export interface ClosingDetailClosing {
  loanNumber: string;
  signingId: string;
  propertyAddress: string;
  scheduledAt: string;
  completedAt: string | null;
  rescheduledTo: string | null;
}

export interface ClosingDetail {
  packageId: number;
  notary: ClosingDetailNotary;
  clients: ClosingDetailClient[];
  closing: ClosingDetailClosing;
}

export const ALERT_SLOT_VARIANTS: readonly SlotVariant[] = [
  "stuck",
  "delayed",
  "over",
];

export function isAlertVariant(variant: SlotVariant): boolean {
  return ALERT_SLOT_VARIANTS.includes(variant);
}
